function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import PropTypes from 'prop-types';
import { Auth } from 'aws-amplify';
import 'scss/footer.scss';
import { mapTextVariableNameToStaticLocalizedText } from 'js/helpers/localization';
import logo from 'images/xinampa.png';
import { Container, Logo, Description, CancelText } from './style';

var Footer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Footer, _React$Component);

  function Footer() {
    _classCallCheck(this, Footer);

    return _possibleConstructorReturn(this, _getPrototypeOf(Footer).apply(this, arguments));
  }

  _createClass(Footer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          userRole = _this$props.userRole,
          history = _this$props.history;
      var dashboard = history ? history.location.pathname.startsWith('/countries') : false;
      var choose_plan = history ? history.location.pathname === '/choose-plan' : false;
      return React.createElement(Container, {
        color: dashboard ? 'white' : 'transparent'
      }, React.createElement("a", {
        href: "http://xinampa.io/",
        target: "_blank",
        rel: "noopener noreferrer"
      }, React.createElement(Logo, {
        href: "",
        src: logo,
        alt: "Xinampa logo"
      })), React.createElement(Description, null, "COSMOS creates, aggregates and generates data insights for the future of Sustainable Energy in Latin America"), React.createElement("span", {
        className: "niuera-footer__text"
      }, mapTextVariableNameToStaticLocalizedText('FOOTER_COPYRIGHT_TEXT')), ['normalCustomer', 'premiumCustomer'].includes(userRole) && (dashboard || choose_plan) ? React.createElement(CancelText, {
        onClick:
        /*#__PURE__*/
        _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee() {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.t0 = fetch;
                  _context.t1 = "".concat(process.env.COSMOS_DATA_API_URL, "/payments/subscriptions/cancelgreement");
                  _context.next = 4;
                  return getApiRequestHeaders();

                case 4:
                  _context.t2 = _context.sent;
                  _context.t3 = {
                    method: 'GET',
                    mode: 'cors',
                    headers: _context.t2
                  };

                  _context.t4 = function (response) {
                    return response.json();
                  };

                  _context.t5 = function (data) {
                    Auth.signOut().then(function () {
                      history.push('/login:cancel-subscription-success');
                    }).catch(function () {
                      history.push('/login');
                    });
                  };

                  _context.t6 = function (err) {
                    // eslint-disable-next-line no-console
                    console.log(err);
                  };

                  _context.next = 11;
                  return (0, _context.t0)(_context.t1, _context.t3).then(_context.t4).then(_context.t5).catch(_context.t6);

                case 11:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }))
      }, "Cancel subscription") : '');
    }
  }]);

  return Footer;
}(React.Component);

Footer.propTypes = {
  history: PropTypes.object,
  userRole: PropTypes.string
};
export { Footer as default };

function getApiRequestHeaders() {
  return _getApiRequestHeaders.apply(this, arguments);
}

function _getApiRequestHeaders() {
  _getApiRequestHeaders = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee6() {
    var session;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return Auth.currentSession();

          case 2:
            session = _context6.sent;
            _context6.next = 5;
            return AuthHelper.refreshCurrentSession();

          case 5:
            return _context6.abrupt("return", {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              cookies: session.accessToken.jwtToken
            });

          case 6:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));
  return _getApiRequestHeaders.apply(this, arguments);
}

var AuthHelper =
/*#__PURE__*/
function () {
  function AuthHelper() {
    _classCallCheck(this, AuthHelper);
  }

  _createClass(AuthHelper, null, [{
    key: "refreshSessionPromise",
    value: function () {
      var _refreshSessionPromise = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4(refreshToken) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", new Promise(
                /*#__PURE__*/
                function () {
                  var _ref2 = _asyncToGenerator(
                  /*#__PURE__*/
                  regeneratorRuntime.mark(function _callee3(resolve, reject) {
                    var user;
                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return Auth.currentAuthenticatedUser();

                          case 2:
                            user = _context3.sent;
                            return _context3.abrupt("return", user.refreshSession(refreshToken,
                            /*#__PURE__*/
                            function () {
                              var _ref3 = _asyncToGenerator(
                              /*#__PURE__*/
                              regeneratorRuntime.mark(function _callee2(err, data) {
                                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                                  while (1) {
                                    switch (_context2.prev = _context2.next) {
                                      case 0:
                                        if (err) reject(err);else {
                                          resolve(data); // THIS IS YOUR REFRESHED ATTRIBUTES/GROUPS
                                        }

                                      case 1:
                                      case "end":
                                        return _context2.stop();
                                    }
                                  }
                                }, _callee2, this);
                              }));

                              return function (_x4, _x5) {
                                return _ref3.apply(this, arguments);
                              };
                            }()));

                          case 4:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, this);
                  }));

                  return function (_x2, _x3) {
                    return _ref2.apply(this, arguments);
                  };
                }()));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      return function refreshSessionPromise(_x) {
        return _refreshSessionPromise.apply(this, arguments);
      };
    }()
  }, {
    key: "refreshCurrentSession",
    value: function () {
      var _refreshCurrentSession = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee5() {
        var session;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return Auth.currentSession();

              case 2:
                session = _context5.sent;
                return _context5.abrupt("return", this.refreshSessionPromise(session.getRefreshToken()));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      return function refreshCurrentSession() {
        return _refreshCurrentSession.apply(this, arguments);
      };
    }()
  }]);

  return AuthHelper;
}();